
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://bsulxuckwzhumdkgnbqj.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJzdWx4dWNrd3podW1ka2duYnFqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDI2OTQ5OTksImV4cCI6MjA1ODI3MDk5OX0.Bbbw-XFZJbVVeTxpjWI2NCtgBX-8gN8Qy1wpVKW0F5k";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    storage: localStorage
  }
});
